import { label_preview_images } from "../components/LabelPreview/Constants"

export const EMAIL_REGEX =
  /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
export const GST_REGEX =
  /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/
export const PAN_REGEX = /[A-Z]{5}[0-9]{4}[A-Z]{1}/
export const INGREDIENT_NAME_REGEX = /^[ A-Za-z0-9%-&\s\']*$/

export const LABEL_LOAD_LIMIT = 16
export const LABEL_DASHBOARD_PAGE_SIZE = 5
export const LABEL_FETCHING_ERROR = "Something went wrong while fetching labels"

export const RECIPE_LOAD_LIMIT = 16
export const RECIPE_DASHBOARD_PAGE_SIZE = 5
export const RECIPE_FETCHING_ERROR =
  "Something went wrong while fetching recipes"
export const INGREDIENTS_FETCHING_ERROR =
  "Something went wrong while fetching ingredients"
export const BASE_RECIPE_FETCHING_ERROR =
  "Something went wrong while fetching base recipes"
export const QRCODE_COLOR_PALETTE = [
  {
    colors: ["#212529", "#F08226", "#526B84"],
    name: "Orange",
  },
  {
    colors: ["#0D4021", "#F0FDF4", "#FF9B53"],
    name: "Green",
  },
  {
    colors: ["#343030", "#0D6EFD", "#38B7B9"],
    name: "Blue",
  },
]
export const validHealthTagsForZomato = [
  "Low Sodium",
  "Low Sugar",
  "Sugar Free",
  "Low Fat",
  "Low Calorie",
  "Source of Fibre",
  "High Fibre",
  "Source of Protein",
  "High Protein",
  "Keto Friendly",
  "Low Carbs",
  "High Iron",
  "Source of Iron",
  "High Calcium",
  "Source of Calcium",
]

export const preperationMethodOptions = [
  "Boiled",
  "Steamed",
  "Pan fried",
  "Deep fried",
  "Baked",
  "Grilled",
  "Tandoori or Roast",
  "Curry",
  "Freshly squeezed or cold pressed",
  "Minimal or no cooking",
]

export const cuisineOptions = [
  { name: "Chinese" },
  { name: "Continental" },
  { name: "Global Fusion" },
  { name: "Italian" },
  { name: "North Indian" },
  { name: "Other Indian" },
  { name: "South Indian" },
  { name: "Thai" },
  { name: "Others" },
]

export const mealCourseOptions = [
  { name: "Beverage" },
  { name: "Dessert" },
  { name: "Main Course" },
  { name: "Starters" },
  { name: "Salads" },
  { name: "Snacks" },
  { name: "Soup" },
  { name: "Others" },
]

export const unitOptions = [{ name: "G" }, { name: "ML" }]

export const recipeTypeOptions = [
  {
    value: "Vegetarian",
    label: "Vegetarian",
  },
  {
    value: "NonVegetarian",
    label: "Non-Vegetarian",
  },
  {
    value: "Vegan",
    label: "Vegan (No animal products including milk, honey)",
  },
]

export const RECIPE_TYPES = {
  BASE_RECIPE: "BASE_RECIPE",
  NEW_RECIPE: "NEW_RECIPE",
  NEW_INGREDIENT: "NEW_INGREDIENT",
  COMBO_MEALS: "COMBO_MEALS",
}

export const PPF_PLAN = {
  starter: "Starter Plan - PPF",
  business: "Business Plan - PPF",
  introductory: "Introductory Plan - PPF",
}

export const MENU_LABELLING_PLAN = {
  starter: "Starter Plan",
  business: "Business Plan",
  introductory: "Introductory Plan",
}

export const BUSINESS_MODEL = {
  ppf: "PPF Model",
}
export const BLACKLIST_USERS = []

export const SELECTED_PLAN_KEY = "selectedPlan"
export const DEFAULT_PLAN_KEY = "plan_NgTcQJy9dq20iK"

export const vegNonVegLogo = {
  NonVegetarian: label_preview_images.nonVegLogo,
  "Non Vegetarian": label_preview_images.nonVegLogo,
  Vegetarian: label_preview_images.vegLogo,
  Vegan: label_preview_images.veganLogo,
  "Contains Egg": label_preview_images.eggLogo,
}

export const UPLOAD_FILE_TYPES = {
  png: "image/png",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  gif: "image/gif",
  bmp: "image/bmp",
  webp: "image/webp",
  svg: "image/svg+xml",
  pdf: "application/pdf",
  doc: "application/msword",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  xls: "application/vnd.ms-excel",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ppt: "application/vnd.ms-powerpoint",
  pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  txt: "text/plain",
  csv: "text/csv",
  json: "application/json",
  zip: "application/zip",
  rar: "application/vnd.rar",
}

export const MULTI_PACK_LABEL_LIMIT = 10

export const DOMESTIC_LABEL_TYPE = {
  MULTI_PACK: "MULTI_PACK",
}

export const API_RESPONSE_STATUS = {
  success: "success",
  failure: "failure",
}

export const NO_RDA_NUTRIENT_ALL_AGE_GROUP = [
  "carbohydrates",
  "free_sugars",
  "cholesterol",
  "calcium",
  "mufa",
  "pufa",
]

export const NO_RDA_NUTRIENT_AGE_GROUP_WISE = {
  "0-6 months": [...NO_RDA_NUTRIENT_ALL_AGE_GROUP, "iron"],
  "7-12 months": [...NO_RDA_NUTRIENT_ALL_AGE_GROUP],
  "1-3 years": [...NO_RDA_NUTRIENT_ALL_AGE_GROUP],
  "4-6 years": [...NO_RDA_NUTRIENT_ALL_AGE_GROUP],
  "7-9 years": [...NO_RDA_NUTRIENT_ALL_AGE_GROUP],
  "10-12 years": [...NO_RDA_NUTRIENT_ALL_AGE_GROUP],
  "13-15 years": [...NO_RDA_NUTRIENT_ALL_AGE_GROUP],
  "16-18 years": [...NO_RDA_NUTRIENT_ALL_AGE_GROUP],
  "Above 18 years": [...NO_RDA_NUTRIENT_ALL_AGE_GROUP],
}

export const DOMESTIC_NUTRITION_KEYS = {
  // --- Mandatory ---
  ENERGY: "energy",
  TOTAL_CARBOHYDRATE: "carbohydrates",
  TOTAL_SUGARS: "free_sugars",
  ADDED_SUGARS: "total_free_sugars",
  PROTEIN: "protein",
  TOTAL_FAT: "total_fat",
  SATURATED_FAT: "total_sfa",
  TRANS_FAT: "trans_fat",
  CHOLESTEROL: "cholesterol",
  SODIUM: "sodium",

  // --- Non-Mandatory ---
  DIETARY_FIBRE: "dietary_fibre",
  ORYZANOL: "oryzanol",
  IRON: "iron",
  CALCIUM: "calcium",
  FOLIC_ACID: "folic_acid",
  IODINE: "iodine",
  VITAMIN_B6: "vitamin_b6",
  VITAMIN_B12: "vitamin_b12",
  VITAMIN_C: "vitamin_c",
  ZINC: "zinc",
  MAGNESIUM: "mangesium", // As provided in the data
  VITAMIN_D: "vitamin_d",
  VITAMIN_K1: "vitamin_k1",
  VITAMIN_B1: "vitamin_b1",
  VITAMIN_B2: "vitamin_b2",
  BIOTIN: "biotin", // vitamin_b7
  VITAMIN_B3: "vitami_b3", // As provided in the data
  PANTOTHENIC_ACID: "eicosa_pentadecanoic_acid", // vitamin_b5
  VITAMIN_E: "vitamin_e",
  VITAMIN_A: "vit_a",
  SELENIUM: "selenium",
  COPPER: "copper",
  POTASSIUM: "potassium",
  CHLORIDE: "chloride",
  MANGANESE: "manganese",
  PHOSPHORUS: "phosphorus",
  MUFA: "mufa",
  PUFA: "pufa",
  OMEGA_3_FATTY_ACIDS: "omega_3",
  OMEGA_6_FATTY_ACIDS: "omega_6",
  CHOLINE: "choline",
  CHROMIUM: "chromium",
  MOLYBDENUM: "molybdenum",
  POLYOLS: "polyols",
  STARCH: "starch",
}

export const DOMESTIC_SCHEMA_KEYS = {
  select_country: "select_country",
  brandId: "brandId",
  "Add Brand": "Add Brand",
  food_name: "food_name",
  flavour: "flavour",
  other_information: "other_information",
  proprietary_product: "proprietary_product",
  proprietary_food_name: "proprietary_food_name",
  show_fssai_category: "show_fssai_category",
  fssai_category_name: "fssai_category_name",
  single_ingredients: "single_ingredients",
  ingredients: "ingredients",
  ingredient_name: "ingredient_name",
  name: "name",
  proportion: "proportion",
  compound: "compound",
  show_ingredient_proportion: "show_ingredient_proportion",
  ingredient: "ingredient",
  ingredient_message: "ingredient_message",
  additives: "additives",
  no_additives: "no_additives",
  finalingredients: "finalingredients",
  vegetarian_and_non_vegetarian: "vegetarian_and_non_vegetarian",
  vegan_certificate: "vegan_certificate",
  organic_product: "organic_product",
  organic_certificate: "organic_certificate",
  organic_certificate_from: "organic_certificate_from",
  agmark_certified: "agmark_certified",
  agmark_certificate: "agmark_certificate",
  tea_board_certified: "tea_board_certified",
  tea_board_certificate: "tea_board_certificate",
  tea_india_certified: "tea_india_certified",
  tea_india_certificate: "tea_india_certificate",
  tea_india_license_number: "tea_india_license_number",
  bis_certified: "bis_certified",
  bis_certificate: "bis_certificate",
  bis_license_number: "bis_license_number",
  fortified: "fortified",
  fortification_certificate: "fortification_certificate",
  fortified_with: "fortified_with",
  irradiated: "irradiated",
  product_name: "product_name",
  purpose: "purpose",
  operating_licence_no: "operating_licence_no",
  natural_product: "natural_product",
  plant_based_product: "plant_based_product",
  allergens: "allergens",
  contains: "contains",
  may_contains: "may_contains",
  my_product_is: "my_product_is",
  ni_info_type: "ni_info_type",
  lab_report: "lab_report",
  your_own_values: "your_own_values",
  PFL_RECIPE_SELECTION: "PFL_RECIPE_SELECTION",
  RECIPE_SEARCH: "RECIPE_SEARCH",
  target_audience: "target_audience",
  age_group: "age_group",
  serving_size: "serving_size",
  serving_size_unit: "serving_size_unit",
  net_quantity: "net_quantity",
  net_quantity_unit: "net_quantity_unit",
  mandatory_nutrient: "mandatory_nutrient",
  non_mandatory_nutrient: "non_mandatory_nutrient",
  industrial_trans_fat_free: "industrial_trans_fat_free",
  manufacturer_by: "manufacturer_by",
  packed_by: "packed_by",
  marketed_by: "marketed_by",
  brand_owner: "brand_owner",
  imported: "imported",
  country_of_origin: "country_of_origin",
  imported_by: "imported_by",
  "Create new address": "Create new address",
  consumer_care: "consumer_care",
  use_storage_instructions: "use_storage_instructions",
  made_in_india: "made_in_india",
  plant_stanol_esters: "plant_stanol_esters",
  plant_stanol_esters_qty: "plant_stanol_esters_qty",
  isomaltulose: "isomaltulose",
  isomaltulose_qty: "isomaltulose_qty",
  annatto_color: "annattto_color",
  "10%_or_more_polyols": "10%_or_more_polyols",
  "10%_or_more_polydextrose": "10%_or_more_polydextrose",
  added_caffeine: "added_caffeine",
  "10%_or_more_sorbitol_and_sorbitol_syrup":
    "10%_or_more_sorbitol_and_sorbitol_syrup",
  trehalose: "trehalose",
  monosodium_glutamate: "monosodium_glutamate",
  added_dietary_fibre: "added_dietary_fibre",
  mixture_of_sweeteners: "mixture_of_sweeteners",
  mandatory_declaration: "mandatory_declaration",
  common_salt_for: "common_salt_for",
  wax: "wax",
  name_of_oil: "name_of_oil",
  refined_oil_name: "refined_oil_name",
  blended_oil: "blended_oil",
  percent_by_coffee: "percent_by_coffee",
  percent_by_chicory: "percent_by_chicory",
  common_salt_for: "common_salt_for",
  package_material_type: "package_material_type",
  brand_registration_number: "brand_registration_number",
  recycling_icon: "recycling_icon",
  pack_shape: "pack_shape",
  unit: "unit",
  pack_dimension: "pack_dimension",
  label_dimension: "label_dimension",
  sku_details: "sku_details",
  mrp_title: "mrp_title",
  mrp: "mrp",
  usp_title: "usp_title",
  date_of_pkg_mfg_title: "date_of_pkg_mfg_title",
  typeOf_packaging_manufacture: "typeOf_packaging_manufacture",
  dateOf_packaging_manufacture: "dateOf_packaging_manufacture",
  useBy_expiry_title: "useBy_expiry_title",
  typeOf_useBy_expiry: "typeOf_useBy_expiry",
  dateOf_useBy_expiry: "dateOf_useBy_expiry",
  batch_number_title: "batch_number_title",
  batch_no: "batch_no",
  add_barcode: "add_barcode",
  bar_code: "bar_code",
  add_barcode_number: "add_barcode_number",
  barcode_number: "barcode_number",
  fssai_guidelines: "fssai_guidelines",
  energy: "energy",
  carbohydrates: "carbohydrates",
  free_sugars: "free_sugars",
  total_free_sugars: "total_free_sugars",
  protein: "protein",
  total_fat: "total_fat",
  total_sfa: "total_sfa",
  sodium: "sodium",
  cholesterol: "cholesterol",
  trans_fat: "trans_fat",
  dietary_fiber: "dietary_fiber",
  vitamin_d: "vitamin_d",
  calcium: "calcium",
  iron: "iron",
  potassium: "potassium",
  salt: "salt",
  name: "name",
  ins_number: "ins_number",
  proportion: "proportion",
  additive_value_show: "additive_value_show",
  nature: "nature",
  common_name: "common_name",
  additive_name: "additive_name",
  aspartame_methyl: "aspartame_methyl",
  acesulfame_potassium: "acesulfame_potassium",
  aspartame_salt: "aspartame_salt",
  saccharins: "saccharins",
  polyols: "polyols",
  sorbitol: "sorbitol",
  sucralose: "sucralose",
  neotame: "neotame",
  stevia_glycoside: "stevia_glycoside",
  usp_rs: "usp_rs",
  usp_unit: "usp_unit",
  usp_auto_calculation: "usp_auto_calculation",
  purity_weight_of_marker_compound: "purity_weight_of_marker_compound",
}

export const COUNTRY_CODE = {
  INDIA: "IND",
  USA: "USA",
  "AUS-NZ": "AUS-NZ",
  UK: "UK",
  GCC: "GCC",
  CANADA: "CA",
  BHUTAN: "BT",
  PHILIPPINES: "PH",
  MALAYSIA: "MY",
  SINGAPORE: "SG",
  HONG_KONG: "HK",
  MULTI: "MULTI",
}

export const DOMESTIC_KEYS_TO_RECIPES_NI_KEYS_MAPPING = {
  // Mandatory Keys
  [DOMESTIC_NUTRITION_KEYS.ENERGY]: "Energy",
  [DOMESTIC_NUTRITION_KEYS.TOTAL_CARBOHYDRATE]: "Carbohydrates",
  [DOMESTIC_NUTRITION_KEYS.TOTAL_SUGARS]: "Free_Sugars",
  [DOMESTIC_NUTRITION_KEYS.ADDED_SUGARS]: "Total_Free_Sugars",
  [DOMESTIC_NUTRITION_KEYS.PROTEIN]: "Protein",
  [DOMESTIC_NUTRITION_KEYS.TOTAL_FAT]: "Total_Fat",
  [DOMESTIC_NUTRITION_KEYS.SATURATED_FAT]: "Total_SFA",
  [DOMESTIC_NUTRITION_KEYS.TRANS_FAT]: "Trans_Fat",
  [DOMESTIC_NUTRITION_KEYS.CHOLESTEROL]: "Cholesterol",
  [DOMESTIC_NUTRITION_KEYS.SODIUM]: "Sodium",
  // Non-Mandatory Keys
  [DOMESTIC_NUTRITION_KEYS.DIETARY_FIBRE]: "Dietary_Fibre",
  [DOMESTIC_NUTRITION_KEYS.IRON]: "Iron",
  [DOMESTIC_NUTRITION_KEYS.CALCIUM]: "Calcium",
  [DOMESTIC_NUTRITION_KEYS.ZINC]: "Zinc",
  [DOMESTIC_NUTRITION_KEYS.POTASSIUM]: "Potassium",
  [DOMESTIC_NUTRITION_KEYS.MAGNESIUM]: "Magnesium", // note the spelling in DOMESTIC_NUTRITION_KEYS is `mangesium`
  [DOMESTIC_NUTRITION_KEYS.MANGANESE]: "Manganese",
  [DOMESTIC_NUTRITION_KEYS.PHOSPHORUS]: "Phosphorus",
  [DOMESTIC_NUTRITION_KEYS.SELENIUM]: "Selenium",
  [DOMESTIC_NUTRITION_KEYS.COPPER]: "Copper",

  // Vitamins
  [DOMESTIC_NUTRITION_KEYS.VITAMIN_A]: "Vit_A",
  [DOMESTIC_NUTRITION_KEYS.VITAMIN_D]: "Vit_D",
  [DOMESTIC_NUTRITION_KEYS.VITAMIN_B1]: "Vit_B1_Thiamine",
  [DOMESTIC_NUTRITION_KEYS.VITAMIN_B2]: "Vit_B2_Riboflavin",
  [DOMESTIC_NUTRITION_KEYS.VITAMIN_B3]: "Vit_B3_Niacin", // from 'vitami_b3'
  [DOMESTIC_NUTRITION_KEYS.VITAMIN_B6]: "Vit_B6_Pyridoxine",
  // VITAMIN_B12 not present in ni_info snippet
  [DOMESTIC_NUTRITION_KEYS.FOLIC_ACID]: "Vit_B9_Folate", // maps your folic_acid to Vit_B9_Folate
  [DOMESTIC_NUTRITION_KEYS.VITAMIN_C]: "Vit_C_Ascorbic_Acid",
  [DOMESTIC_NUTRITION_KEYS.BIOTIN]: "Biotin",
  [DOMESTIC_NUTRITION_KEYS.VITAMIN_E]: "Vit_E_α_Tocopherol", // best guess from ni_info snippet
  [DOMESTIC_NUTRITION_KEYS.VITAMIN_K1]: "Phylloquinones", // best guess if you want Vit K1 → Phylloquinones
  [DOMESTIC_NUTRITION_KEYS.PANTOTHENIC_ACID]: "Vit_B5_Pantothenic_Acid",

  // Fatty Acids
  [DOMESTIC_NUTRITION_KEYS.MUFA]: "Total_MUFA",
  [DOMESTIC_NUTRITION_KEYS.PUFA]: "Total_PUFA",
}

export const FOLSOL_PUBLIC_S3_BUCKET_URL = `https://${process.env.S3_BUCKET_NAME}.s3.ap-south-1.amazonaws.com/public`

export const CHOOSE_NI_VALUES_OPTIONS = [
  "My Recipes",
  "Lab Report",
  "I want to fill in my own NI values",
]

export const NI_VALUES_OPTIONS = {
  MY_RECIPES: "My Recipes",
  LAB_REPORT: "Lab Report",
  OWN_VALUES: "I want to fill in my own NI values",
}

export const SERVINGS_SIZE_UNITS_OPTIONS = ["g", "L", "ml", "kg"]
export const NET_QUANTITY_UNIT_OPTIONS = ["g", "L", "ml", "kg"]
export const YES_NO_OPTIONS = ["Yes", "No"]
export const COMMON_SALT_USING_REASONS_OPTIONS = [
  "For Iodisation",
  "For Iron fortification",
  "For Animal use",
  "For Preservation and not meant for direct consumption",
  "For Infant Food products",
  "For medicine",
  "For Industrial Use",
]
export const PACK_SHAPE_UNIT_OPTIONS = ["cm", "mm"]

export const DOMESTIC_TIMER_LAUNCH_DATE = 1748946116 //JUN 3, 2025
